<template>
<v-container fluid class="pa-0">
	<!--get info-->
	<v-form v-model="valid" ref="form" validation>
		<v-container>
			<v-row>
				<v-col cols="12" sm="4" md="2">
					<v-select dense
						v-model="gameId"
						:items="games"
						color="#1A237E"
						item-color="grey"
						label="game id"
						required
						:rules="requiredRules">
					</v-select>
				</v-col>
				<v-col cols="12" sm="2" md="1">
					<v-select dense
						v-model="round"
						:items="items"
						color="#1A237E"
						item-color="grey"
						label="round"
						required
						:rules="requiredRules">
					</v-select>
				</v-col>
				<v-col cols="12" sm="4" md="2">
					<v-select dense
						v-model="company"
						:items="teams"
						color="#1A237E"
						item-color="grey"
						label="company"
						required
						:rules="requiredRules">
					</v-select>
				</v-col>
				<!--load data-->
				<v-col cols="12" sm="3" md="2" v-if="valid" class="mt-4">
					<v-btn color="#1A237E" small dark
						class="text-lowercase"
						:disabled="!valid || Boolean(error)"
						@click="getInfo"
						>load
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-form>
	<v-divider class="mt-4"></v-divider>

	<v-tabs v-model="tab" height="35"
		align-with-title
		background-color="primary"
		dark>
		<v-tab :to="link(item)" ripple
			class="text-capitalize"
			exact-active-class
			v-for="item in itemsTab"
			:key="item">
			{{ item }}
		</v-tab>
	</v-tabs>

	<v-tabs-items v-model="tab" continuous>
		<v-tab-item value="/admin/teams/information">
			<info :gameId="gameId"></info>
		</v-tab-item>
		<v-tab-item value="/admin/teams/products">
			<products 
				:company="company"
				:gameId="gameId"
				:round="round">
			</products>
		</v-tab-item>
		<v-tab-item value="/admin/teams/sales">
			<sales
				:company="company"
				:gameId="gameId"
				:round="round">
			</sales>
		</v-tab-item>
		<v-tab-item value="/admin/teams/retail">
			<retail 
				:company="company"
				:gameId="gameId"
				:round="round">
			</retail>
		</v-tab-item>
		<v-tab-item value="/admin/teams/promotion">
			<promotion
				:company="company"
				:gameId="gameId"
				:round="round">
			</promotion>
		</v-tab-item>
		<v-tab-item value="/admin/teams/finance">
			<finance :gameId="gameId" :round="round"></finance>
		</v-tab-item>
	</v-tabs-items>
	</v-container>
</template>
<script>

	import Info from './teams/Info.vue'
	import Products from '../decisions/ProductManagement.vue'
	import Sales from '../decisions/Sales.vue'
	import Retail from '../decisions/Retail.vue'
	import Promotion from '../decisions/Promotion.vue'
	import Finance from '../decisions/Finance.vue'


	export default {
		data (){
			return {
				valid: false,
				tab: 0,
				error: '',
				company: '',
				round: '0',
				items: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
				itemsTab: ['Information','Products','Sales', 'Retail','Promotion', 'Finance'],
				requiredRules: [v => !!v || 'this field is required'],
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			games () {
				const games = this.$store.getters.userData.games
				if (games) return Object.keys(games)
				else return []
			},
			currentGame () {
				return this.$store.getters.currentGame
			},
			gameId: {
				get () {
					return this.currentGame
				},
				set (val) {
					return val
				}
			},
			teams () {
				return this.$store.getters.teams
			}, 
			title(){
				return this.$route.name
			}
		},
		methods: {
			link (item) {
				const name = item.toLowerCase()
				return `/admin/teams/${name}`
			},
			async getInfo () {
				
				if(this.$refs.form.validate()) {
					
					//const commit = `fetch${this.$route.name}`
					const obj = {
							gameId: this.gameId,
							round: this.round,
							company: this.company
						}
					try {
						//get info
						//for trademarks
						await this.$store.dispatch('fetchProducts', obj)	
						
						if (this.title == 'admin.teams.retail') {
							
							await this.$store.dispatch('fetchChannels', obj)
							await this.$store.dispatch('fetchIndependentChains', obj)
						}
						else if (this.title == 'admin.teams.promotion') {
							await this.$store.dispatch('fetchSpots', obj)
						}
					}
					catch (error) {
						throw error
					}
				}
			}
		},
		components: {
			Info,
			Products,
			Sales,
			Retail,
			Promotion,
			Finance
			
		}
	}
</script>
